/* eslint-disable  @typescript-eslint/no-unsafe-argument */
type Debounce = {
  callback: (...args: any[]) => void;
  delay?: number;
};

export const debounce = ({ callback, delay = 500 }: Debounce) => {
  let timeoutId: NodeJS.Timeout;

  return (...args: any[]) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => callback(...args), delay);
  };
};
